import { FC, ReactNode } from "react";
import { VerificationCodeInput } from "../VerificationCodeInput";
import { ResendCodeButton, ResendCodeButtonProps } from "../ResendCodeButton";
import { ValidatedInputProps, InputCommonProps } from "../Inputs/Common";
import styles from "./VerificationCodeEntry.module.scss";

export interface VerificationCodeEntryProps extends ValidatedInputProps, InputCommonProps {
    value: string;
    onChange: (value: string) => void;
    autoFocus?: boolean;
    length?: number;

    onResend: () => Promise<void> | void;
    codeSentAt: Date | null;
    cooldownSeconds: number | undefined;
    busy?: boolean;
    resendLabel: ReactNode;
    cooldownLabel: (countdownNode: ReactNode) => ReactNode;
    resendSeverity?: ResendCodeButtonProps["severity"];
    resendSize?: ResendCodeButtonProps["size"];
    resendClassName?: string;
}

export const VerificationCodeEntry: FC<VerificationCodeEntryProps> = (props) => {
    const {
        validator,
        validations,
        customMessages,
        label,
        value,
        onChange,
        autoFocus,
        length,
        onResend,
        codeSentAt,
        cooldownSeconds,
        busy,
        resendLabel,
        cooldownLabel,
        resendSeverity,
        resendSize,
        resendClassName
    } = props;

    return (
        <div className={styles.container}>
            <VerificationCodeInput
                id={props.id}
                validator={validator}
                validations={validations}
                customMessages={customMessages}
                label={label}
                value={value}
                onChange={onChange}
                autoFocus={autoFocus}
                length={length}
            />

            <ResendCodeButton
                onResend={onResend}
                codeSentAt={codeSentAt}
                cooldownSeconds={cooldownSeconds}
                busy={busy}
                resendLabel={resendLabel}
                cooldownLabel={cooldownLabel}
                severity={resendSeverity}
                size={resendSize}
                className={resendClassName}
            />
        </div>
    );
};
